// LLM generated - Model Claude 4 Sonnet
type IconShieldAuroraProps = {
  size?: number;
  strokeWidth?: number;
};

export default function IconShieldAurora({ size = 28, strokeWidth = 2.5 }: IconShieldAuroraProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5 14.6667L12.8333 17L17.5 12.3334M14 4.16669C16.7251 6.57769 20.2819 7.83301 23.9167 7.66669C24.4459 9.46687 24.6078 11.3551 24.3928 13.2191C24.1779 15.0831 23.5904 16.8848 22.6653 18.5173C21.7402 20.1498 20.4965 21.5796 19.0079 22.7219C17.5193 23.8642 15.8163 24.6956 14 25.1667C12.1838 24.6956 10.4807 23.8642 8.99215 22.7219C7.50356 21.5796 6.25977 20.1498 5.33471 18.5173C4.40964 16.8848 3.82217 15.0831 3.6072 13.2191C3.39223 11.3551 3.55415 9.46687 4.08334 7.66669C7.71813 7.83301 11.2749 6.57769 14 4.16669Z"
        stroke="url(#paint0_linear_shield_aurora)"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_shield_aurora"
          x1="3.51501"
          y1="14.6667"
          x2="24.485"
          y2="14.6667"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1BC4CF" />
          <stop offset="1" stopColor="#7F1A93" />
        </linearGradient>
      </defs>
    </svg>
  );
}

IconShieldAurora.displayName = 'IconShieldAurora';
